import React, { useState } from 'react'
import styled from 'styled-components'

const Dropdown = ({ label = '', icon = '', width, disabled = false, render = null}) => {
    const [open, changeOpen] = useState(false)
    const [title, setTitle] = useState({
        label: <span>{label}</span>,
        value: label
    })

    const handleChangeTitle = (label: string, editable: boolean) => {
        if(editable)
            setTitle({
                label: <input onChange={(e) => handleChangeTitle(e.target.value, true)}></input>,
                value: label        
            })
        else
            setTitle({
                label: <span>{label}</span>,
                value: label        
            })
    }

    const toggle = () => changeOpen(prev => render && changeOpen(!prev))

    return <Container className={open ? 'open' : 'closed' + (disabled ? ' disabled' : '')} width={width}>
        <Select onClick={toggle}>
            <Visible>
                <Label>
                    <span>{label}</span>
                </Label>
                <Caret>
                    <i className={`fas fa-chevron-${open ? 'up' : 'down'} fa-lg`} />
                </Caret>
            </Visible>
        </Select>
        {open && render && <Content>{render()}</Content>}
    </Container>
}

export default Dropdown

const Container = styled.div`
    display: block;
    position: relative;
    /* z-index: 999999; */
    background-color: #ffffff;
    margin-bottom: 10px;
    &.disabled {
        background: rgba(204, 204, 204, 0.6);
        opacity: 0.4;
        cursor: not-allowed;
    }
    border: 1px solid #ccc;
    border-radius: 3px;
    &.open {
        margin-bottom: 100px;
        border-bottom: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        z-index:2;
    }
    padding-left: 16px;
    width: ${props => `${props.width}px` || ''};
`
const Select = styled.div`
    /* height: 40px; */
    user-select: none;
`
const Visible = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* height: 40px; */
`
const Caret = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    opacity: 0.7;
    :hover { opacity: 1 }
    cursor: pointer;
    > i { color: #37a3ef }
`
const Label = styled.div`
    > i { color: #37a3ef }
    > span {
        padding-left: 12px;
        /* text-transform: uppercase; */
        font-weight: bold;
        font-size: 14px;
    }
`
const Content = styled.div`
    position: absolute;
    border: 1px solid #ccc;
    border-radius: 3px;
    border-top: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    width: calc(100% + 2px);
    left: -1px;
    background-color: #EEEEEE;
    padding: 8px 16px;
    margin-top: -1px;
`
